import { all, takeEvery } from 'redux-saga/effects';
import { saveConfigurationsAction } from '../actions';
import { saveConfigurationsSaga } from './saveConfigurationsSaga';

export function* volumeDriverConfigurationsWatcherSaga() {
  yield all([takeEvery(saveConfigurationsAction.TYPE, saveConfigurationsSaga)]);
}
